import React, { useEffect, useState } from 'react';
import TController from './TController';
import { Box } from '@mui/material';
import { PersitedDatePicker } from '../../../../../../components/common';
import { useQuery } from '../../../../../../hooks/UseQuery';
import axios from 'axios';
import ParetoChart from './ParetoChart';
import { GraphHead } from '../../../../../../components/common/GraphHeading';
interface IProps {
  apiData: any;
  title1?:any;
  title2?:any;
}
const DefectWiseQty = ({ apiData, title1 , title2}: IProps) => {
  return (
    <div>
      <TController apiData={apiData}/>
      <GraphHead style={{ width: '80vw', margin: '14rem' }}>
          <p>{title1}</p>
      <ParetoChart apiData={apiData} />
      </GraphHead>
      <GraphHead style={{ width: '80vw', margin: '14rem' }}>
          <p>{title2}</p>
      <ParetoChart apiData={apiData} machineWise={true}/>
      </GraphHead>
          
    </div>
  );
};

export default DefectWiseQty;
